document.addEventListener("DOMContentLoaded", function () {
  if (!customElements.get("collection-tabs")) {
    customElements.define(
      "collection-tabs",
      class CollectionTabs extends HTMLElement {
        constructor() {
          super();
          this.tabButtons = this.querySelectorAll("[data-tab-button]");
          this.tabContents = this.querySelectorAll("[data-tab-content]");
          this.handleTabClick = this.handleTabClick.bind(this);

          this.tabButtons.forEach((button) => {
            button.addEventListener("click", this.handleTabClick);
          });
        }

        connectedCallback() {}

        handleTabClick(e) {
          try {
            const selectedCollection = e.target.dataset.coll;
            this.tabButtons.forEach((el) => el.classList.remove("selected-coll-btn"));
            e.target.classList.add("selected-coll-btn");
            this.tabContents.forEach((el) => el.classList.remove("selected-coll"));
            this.querySelector(`.featured_${selectedCollection}`).classList.add("selected-coll");
          } catch (error) {
            console.log(error);
          }
        }
      }
    );
  }
});
